
import React, { FC, useState, useEffect, memo, useMemo, useRef } from "../../../lib/teact/teact";
import Button from "../../ui/Button";

import { getWSClient, wsClientInstance } from "../websocket/nativeapp";
import './ketquaxoso.scss';
import { createEmptyKetQuaXoSo, IKetQuaXoSo } from "./types";
import TabList from "../../ui/TabList";
import ViewKetQuaByDai from "./viewKetQuaByDai";
import ViewKetQuaMienBac from "./viewKetQuaMienBac";
import { getCurrentTime } from "../utils/DateTimeUtils";
type OwnProps = {
    onClose: () => void;
    isOpen: boolean;
}

type State = {
    kqxs: IKetQuaXoSo,
    loading: false,
    isOpen: boolean;
    activeTab: number;
    title: string;
}
const KetQuaXoSo: FC<OwnProps> = ({
    onClose,
    isOpen
}) => {
    const [state, setState] = useState<State>({
        kqxs: createEmptyKetQuaXoSo(),
        loading: false,
        isOpen: false,
        activeTab: 0,
        title: "TT Minh Ngọc"
    })
    function getDisplayTime(): string {
        const time = getCurrentTime()
        // if (!stateRef.current.isOpen)
        //     return time.substring(3, 10)
        // else
        return time
    }
    const stateRef = useRef(state); // Lưu reference của state
    useEffect(() => {
        stateRef.current = state;
    }, [state]); // Cập nhật ref mỗi khi state thay đổi
    ////
    const wsClient = wsClientInstance;
    useEffect(() => {
        // Định nghĩa callback
        const handleError = (error: string) => {
            setState(prev => ({ ...prev, title: error }));
        };

        const handleConnect = (msg: string) => {
            setState(prev => ({ ...prev, title: msg }));
        };

        const handleClose = (msg: string) => {
            setState(prev => ({ ...prev, title: msg }));
        };

        const handleMessage = (message: string) => {
            try {
                const data = JSON.parse(message);
                if (data && data.MB) {
                    setState(prev => ({ ...prev, kqxs: data, title: getDisplayTime() }))
                }
            } catch (e) {
                console.log(e);
            }
        };

        // Gán callback
        wsClient.onMessageError = handleError;
        wsClient.onConnect = handleConnect;
        wsClient.onCloseConnection = handleClose;
        wsClient.onMessageReceived = handleMessage;

        // Cleanup khi unmount
        return () => {
            wsClient.onMessageError = undefined;
            wsClient.onConnect = undefined;
            wsClient.onCloseConnection = undefined;
            wsClient.onMessageReceived = undefined;
        };

    }, [wsClient]); // wsClient là singleton, dependency này OK
    function hideMe() {
        setTimeout(() => {
            const element = document.querySelector(".kqxs-container") as HTMLElement;
            if (!state.isOpen) {

                element.style.left = `${0}px`;      // Cập nhật vị trí trái của div
                element.style.bottom = `${0}px`;
                element.style.top = `20svh`;
            } else {
                element.style.left = `${0}px`;      // Cập nhật vị trí trái của div
                element.style.bottom = `${0}px`;
                element.style.top = `calc(100% - 3rem)`;
            }
        }, 10)

        setState(prev => ({ ...prev, isOpen: !prev.isOpen }))

    }
    function makeDraggable(element: HTMLElement) {
        let isDragging = false;
        let offsetX = 0;
        let offsetY = 0;

        // Lấy kích thước màn hình và kích thước của div
        const getBounds = () => {
            const rect = element.getBoundingClientRect();
            return {
                minX: -rect.width + 50,
                minY: - rect.height + 50,
                maxX: window.innerWidth - 80,
                maxY: window.innerHeight - 49,
            };
        };
        function isShowing(element: HTMLElement): boolean {
            return element.className.indexOf("show") > -1;
        }
        // 📌 Dùng cho máy tính (sự kiện chuột)
        element.addEventListener("mousedown", (e) => {
            if (isShowing(element)) {
                return;
            }
            isDragging = true;
            offsetX = e.clientX - element.offsetLeft;
            offsetY = e.clientY - element.offsetTop;
            element.style.cursor = "grabbing";
        });

        document.addEventListener("mousemove", (e) => {
            if (isShowing(element)) {
                return;
            }
            if (isDragging) {
                const bounds = getBounds();  // Lấy giới hạn
                let newX = e.clientX - offsetX;
                let newY = e.clientY - offsetY;

                // Giới hạn trong màn hình
                newX = Math.max(bounds.minX, Math.min(bounds.maxX, newX));
                newY = Math.max(bounds.minY, Math.min(bounds.maxY, newY));

                element.style.left = `${newX}px`;
                element.style.top = `${newY}px`;
            }
        });

        document.addEventListener("mouseup", () => {
            if (isShowing(element)) {
                return;
            }
            isDragging = false;
            element.style.cursor = "pointer";
        });

        // 📱 Dùng cho điện thoại (sự kiện cảm ứng)
        element.addEventListener("touchstart", (e) => {
            if (isShowing(element)) {
                return;
            }
            isDragging = true;
            const touch = e.touches[0];
            offsetX = touch.clientX - element.offsetLeft;
            offsetY = touch.clientY - element.offsetTop;
        });

        document.addEventListener("touchmove", (e) => {
            if (isShowing(element)) {
                return;
            }
            if (isDragging) {
                const bounds = getBounds();  // Lấy giới hạn
                const touch = e.touches[0];
                let newX = touch.clientX - offsetX;
                let newY = touch.clientY - offsetY;

                // Giới hạn trong màn hình
                newX = Math.max(bounds.minX, Math.min(bounds.maxX, newX));
                newY = Math.max(bounds.minY, Math.min(bounds.maxY, newY));

                element.style.left = `${newX}px`;
                element.style.top = `${newY}px`;
            }
        });

        document.addEventListener("touchend", () => {
            if (isShowing(element)) {
                return;
            }
            isDragging = false;
        });
    }


    useEffect(() => {
        const element = document.querySelector(".kqxs-container") as HTMLElement;
        makeDraggable(element);
    }, [])
    const tabsDai = useMemo(() => {

        const dais: any[] = [];
        state.kqxs.MN.KetQuas.forEach(dai => {
            dais.push({ title: dai.DaiID });
        });
        state.kqxs.MT.KetQuas.forEach(dai => {
            dais.push({ title: dai.DaiID });
        });
        state.kqxs.MB.KetQuas.forEach(dai => {
            dais.push({ title: dai.DaiID });
        });
        //dais.push(...dais)
        return dais

    }, [state.kqxs])
    function renderKetQuaTungDai() {
        const curTab = tabsDai[state.activeTab];
        let dai = state.kqxs.MN.KetQuas.find(d => d.DaiID === curTab.title);
        if (dai) {
            return <ViewKetQuaByDai kqByDai={dai} />
        } else {
            dai = state.kqxs.MT.KetQuas.find(d => d.DaiID === curTab.title);
            if (dai) {
                return <ViewKetQuaByDai kqByDai={dai} />
            } else {
                dai = state.kqxs.MB.KetQuas.find(d => d.DaiID === curTab.title);
                if (dai) {
                    return <ViewKetQuaMienBac kqByDai={dai} />
                }
            }

        }
    }
    return (
        <div className={state.isOpen ? "kqxs-container show" : "kqxs-container hide"}>
            <div className="kqxs-header">
                <Button onClick={hideMe} round size="tiny">
                    <i className={state.isOpen ? "fa fa-compress" : "fa fa-expand"}></i>
                </Button>
                {state.isOpen &&
                    <div onClick={()=>{
                        if (wsClientInstance.ws?.readyState === WebSocket.OPEN)  {
                            wsClientInstance.close();
                        } else {
                            wsClientInstance.closeAndReconnect();
                        }
                         
                    }}>Trực tiếp Minh Ngọc</div>
                }
                <div>{state.title}</div>
                {/* <div>
                    <DropdownMenu positionX="right" positionY="top">
                        <MenuItem>
                            <Button round size="tiny">
                                <i className="fa fa-cog"></i>
                            </Button>
                        </MenuItem>
                    </DropdownMenu>
                </div> */}
            </div>
            <div className="kqxs-body">
                <TabList tabs={tabsDai} onSwitchTab={(index: number) => {
                    setState(prev => ({ ...prev, activeTab: index }))
                }} activeTab={state.activeTab} />
                {renderKetQuaTungDai()}
            </div>
        </div>
    )
}
export default memo(KetQuaXoSo);